import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

const spec: any = {
    us: '_us',
    ca: '_us',
    en: '',
};

const guide: any = {
    jp: '_jp',
    us: '',
};

export default function Q() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('wave2portableairconditioner');

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-Q .viewport-wrapper', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-Q .viewport-wrapper',
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
    }, []);

    return (
        <div className={`wave2-detail-Q ${css.wave2DetailQ}`}>
            <div className="viewport-wrapper">
                <p className="title">{t('detail.sectionQ_title')}</p>
                <div className="item-wrapper">
                    <div className="grid-a">
                        <p className="text">{t('detail.wave2')}</p>
                        <NextImage
                            webpSrc={require(`@publicLocal/wave2/detail/ef_wave2${spec[locale] || spec.en}.webp`)}
                            src={require(`@publicLocal/wave2/detail/ef_wave2${spec[locale] || spec.en}.png`)}
                            alt={t('detail.sectionP_title')}
                            aria-label={t('detail.sectionP_title')}
                        />
                    </div>
                    <div className="grid-b grid-box">
                        <p className="text">{t('detail.sectionQ_item4')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/covers_a.webp')}
                            src={require('@publicLocal/wave2/detail/covers_a.png')}
                            alt={t('detail.sectionQ_item4')}
                            aria-label={t('detail.sectionQ_item4')}
                        />
                    </div>
                    <div className="grid-c grid-box">
                        <p className="text">{t('detail.sectionQ_item5')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/covers_b.webp')}
                            src={require('@publicLocal/wave2/detail/covers_b.png')}
                            alt={t('detail.sectionQ_item5')}
                            aria-label={t('detail.sectionQ_item5')}
                        />
                    </div>
                    <div className="grid-d grid-box">
                        <p className="text">{t('detail.sectionQ_item3')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/covers_c.webp')}
                            src={require('@publicLocal/wave2/detail/covers_c.png')}
                            alt={t('detail.sectionQ_item3')}
                            aria-label={t('detail.sectionQ_item3')}
                        />
                    </div>
                    <div className="grid-e grid-box">
                        <p className="text">{t('detail.sectionQ_item2')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/exhaust_d.webp')}
                            src={require('@publicLocal/wave2/detail/exhaust_d.png')}
                            alt={t('detail.sectionQ_item2')}
                            aria-label={t('detail.sectionQ_item2')}
                        />
                    </div>
                    <div className="grid-f grid-box">
                        <p className="text">{t('detail.sectionQ_item1')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/exhaust_e.webp')}
                            src={require('@publicLocal/wave2/detail/exhaust_e.png')}
                            alt={t('detail.sectionP_title')}
                            aria-label={t('detail.sectionP_title')}
                        />
                    </div>
                    <div className="grid-g grid-box">
                        <p className="text">{t('detail.sectionQ_item6')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/vent_board.webp')}
                            src={require('@publicLocal/wave2/detail/vent_board.png')}
                            alt={t('detail.sectionQ_item6')}
                            aria-label={t('detail.sectionQ_item6')}
                        />
                    </div>
                    <div className="grid-h grid-box">
                        <p className="text">{t('detail.sectionQ_item7')}</p>
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/drain_pipe.webp')}
                            src={require('@publicLocal/wave2/detail/drain_pipe.png')}
                            alt={t('detail.sectionQ_item7')}
                            aria-label={t('detail.sectionQ_item7')}
                        />
                    </div>
                    <div className="grid-i grid-box">
                        <p className="text">{t('detail.sectionQ_item8')}</p>
                        <NextImage
                            webpSrc={require(`@publicLocal/wave2/detail/guide${guide[locale] || guide.us}.webp`)}
                            src={require(`@publicLocal/wave2/detail/guide${guide[locale] || guide.us}.png`)}
                            alt={t('detail.sectionQ_item8')}
                            aria-label={t('detail.sectionQ_item8')}
                        />
                    </div>
                </div>
                {/* <p className="desc">{t('detail.sectionQ_desc')}</p> */}
            </div>
        </div>
    );
}
